import React, { useState, useEffect } from "react";
import axiosInstance from "../../../../axios";
import Button from "../../../Other/element/Button";
import ChapterDocument from "../../../Courses/CourseDetails/CourseChapterDetails/chapterDocument";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { getS3URL } from "../../../../_helpers";
import { Link, useNavigate } from "react-router-dom";
import { FetchNext } from "../../../Other/FetchNext/FetchNext";
import { connect, useDispatch } from "react-redux";
import { courseActions } from "../../../../_actions";

const ViewAward = ({ isFetching, courses }) => {
  const dispatch = useDispatch();
  const { all } = courses;
 // console.log("all123", all);
  const [fetchAwards, setFetchAwards] = useState([]);
  const [printCertificate, setPrintCertificate] = useState(false);
  const [cerftificateUrl, setCertificateUrl] = useState();

  const showHandler = (url) => {
    setCertificateUrl(url);
    setPrintCertificate(!printCertificate);
  };
  const navigate = useNavigate();
  const slugify = (text) => {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  };
  const handleViewProgram = (course) => {
    const slug = slugify(course.CourseName);
    const id = course.ID;
    //console.log(`Navigating to: /${slug}-${id}`);
    // navigate(`/${slug}/${id}`, { state: { course: course } });
    navigate(`/${slug}`, { state: { course: course } });
  };
  useEffect(() => {
    if (!all.currentPage) {
      dispatch(courseActions.viewAwardCourse(1));
    }
  }, []);
  const handleFetchNext =
    (isFetching, currentPage, totalPage) => (observer) => {
      if (!isFetching && currentPage < totalPage) {
        dispatch(courseActions.viewAwardCourse(++currentPage));
      } else {
        observer.disconnect();
      }
    };
  return (
    <>
      <div className="dashboard-container-new !mx-5 !mt-5">
            <p>Awards</p>
      </div>
      {all?.courses?.length === 0 && (
        <div className="no-record-award">
          <span className="record-not-found">No Record found</span>
        </div>
      )}

      {all?.courses.map((element, index) => (
        <div className="main studentPurchase" key={index}>
          <div className="img-container">
            <img
              src={getS3URL(element.imageFiles[0]?.fileName)}
              className="img"
              alt="courseImage"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = require("../../../../assets/images/bgimages.webp");
              }}
            />
          </div>

          <div className="content">
            <div className="content-inner">
              <div className="inner-top">
                <div className="inner-top-flex">
                  <div className="right studentname">
                    <p>Student Name: {element.CreatedBy} </p>
                  </div>
                </div>
                <div className="inner-top-flex">
                  <p className="courseNameResponsive">
                    Course Name: {element.CourseName}
                  </p>
                </div>
                <div className="inner-top-flex">
                  <p className="courseNameResponsiveAgain">
                    createdOn: {new Date(element.CreatedOn).toLocaleString()}
                  </p>
                </div>
              </div>
            </div>

            <div className="list-btn-div">
              <div className="view-section downloadCertificate">
                <Button
                  title="Certificate"
                  className="btn"
                  backgroundColor="#4169e1"
                  textColor="#FFFFFF"
                  handleClick={() => showHandler(element.fileName)}
                />
              </div>
              <div className="view-section">
                {/* <Link
                  className="btn-edit-content quickview"
                  to={{
                    pathname: `/categories/${element.ID}`,
                  }}
                >
                  QUICK VIEW
                </Link> */}
                <button
                  className="btn quickview !bg-[#264b82]"
                  onClick={() => handleViewProgram(element)}
                >
                  QUICK VIEW
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
      {all.currentPage < all.totalPage && (
        <FetchNext
          isFetching={isFetching}
          currentPage={all.currentPage}
          handleFetchNext={handleFetchNext(
            isFetching,
            all.currentPage,
            all.totalPage
          )}
        />
      )}

      {printCertificate && (
        <OverlayContainer>
          <ChapterDocument
            type={"pdf"}
            url={getS3URL(cerftificateUrl)}
            closeHandler={showHandler}
            show={printCertificate}
          />
        </OverlayContainer>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  //console.log("state", state);
  const { isFetching } = state.course;
  const { viewAwardCourse } = state.course;
  //console.log("viewAwardCourse", viewAwardCourse);
  //console.log("isFetching", isFetching);
  return {
    isFetching: isFetching,
    courses: viewAwardCourse || {},
  };
};

export default connect(mapStateToProps)(ViewAward);
